import { gql, useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";

const FALLBACK_QUERY = gql`
  {
    __typename
  }
`;

const QueryExecutor = ({ document, onQueryState }) => {
  const { loading, error, data } = useQuery(document || FALLBACK_QUERY, {
    skip: !document,
  });
  const onQueryStateRef = useRef(onQueryState);
  onQueryStateRef.current = onQueryState;

  useEffect(() => {
    if (!onQueryStateRef.current || loading) {
      return;
    }

    const queryData = data || {};
    onQueryStateRef.current((prev) => {
      const nextJson = JSON.stringify({ queryData, error });
      const prevJson = JSON.stringify({
        queryData: prev.queryData,
        error: prev.error,
      });
      return prevJson === nextJson ? prev : { queryData, loading, error };
    });
  }, [data, loading, error]);

  useEffect(() => {
    if (loading && onQueryStateRef.current) {
      onQueryStateRef.current((prev) =>
        prev.loading ? prev : { ...prev, loading: true }
      );
    }
  }, [loading]);

  return null;
};

QueryExecutor.propTypes = {
  document: PropTypes.object,
  onQueryState: PropTypes.func.isRequired,
};

export default QueryExecutor;
